import { render, staticRenderFns } from "./Textarea.vue?vue&type=template&id=2e1e30dc&scoped=true"
import script from "@/controllers/componentHooks/inputs/textarea/index.js?vue&type=script&lang=js&external"
export * from "@/controllers/componentHooks/inputs/textarea/index.js?vue&type=script&lang=js&external"
import style0 from "./Textarea.css?vue&type=style&index=0&id=2e1e30dc&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1e30dc",
  null
  
)

export default component.exports